import React from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import ErrorMessage from '../../../ErrorMessage';
import TpClientInvoiceService from '../../../../Services/TpClientInvoiceService';
import LoadingIcon from '../../../LoadingIcon';

export default class TpCreditMemoTpClientInvoiceSelect extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    filterCleared: false,
    fieldName: 'defaultFieldname',
    onChange: () => {},
    idFilter: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
      loading: true,
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.idFilter !== prevProps.idFilter) {
      this.setState({ loading: true });
      this.populateListData();
    }
  }

  populateListData() {
    if (!this.props.idFilter) {
      this.setState({ selectValues: [], loading: false });
      return;
    }

    TpClientInvoiceService.GetListByClientId(this.props.idFilter, true)
      .then((result) => {
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result
          .sort((a, b) => (a.contactName > b.contactName ? 1 : b.contactName > a.contactName ? -1 : 0))
          .forEach((invoice, index) => {
            optValues.push({
              label: `${invoice.tpClientInvoiceId} - ${invoice.contactName}`,
              value: invoice.tpClientInvoiceId,
              disabled: false,
            });
          });
        this.setState({ selectValues: optValues, loading: false });
      })
      .catch(() => {
        this.setState({ selectValues: [], loading: false });
        ErrorMessage.SetErrorMessage('TCMTCIS58');
      });
  }

  render() {
    return this.state.loading ? (
      <LoadingIcon
        loading={true}
        className='h6'
      />
    ) : (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        filterCleared={this.props.filterCleared}
        selectValues={this.state.selectValues}
      />
    );
  }
}
